<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <video class="bg-video" autoplay loop muted playsinline>
        <source src="@/assets/1678779171725-jwprOaEf.mp4" type="video/mp4">
      </video>
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <!-- Header 组件 -->
        <PageHeader :showNav="true" activeNavKey="insight"/>

        <div class="center">
          <!-- 主要内容区域 -->
          <div class="main-content">
            <!-- 左右布局 -->
            <div class="content-layout">
              <!-- 左侧区域 -->
              <div class="left-section" style="position: relative;">
                <!-- 数据列表覆盖层 -->
                <div v-if="showDataList" class="data-list-overlay">
                  <div class="data-list-container">
                    <div class="data-list-header">
                      <h3>{{ selectedCard }} 数据列表</h3>
                      <button class="close-button" @click="closeDataList">关闭</button>
                    </div>
                    <div class="data-table-wrapper">
                      <div class="data-table-container">
                        <table class="data-table">
                          <thead>
                          <tr>
                            <th v-for="column in tableColumns" :key="column.prop">
                              {{ column.label }}
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item, index) in paginatedData" :key="index">
                            <td v-for="column in tableColumns" :key="column.prop">
                              {{ item[column.prop] }}
                            </td>
                          </tr>
                          </tbody>
                        </table>
                        <div v-if="paginatedData.length === 0" class="empty-message">
                          暂无数据
                        </div>
                      </div>
                    </div>
                    <div class="pagination">
                      <button @click="prevPage" :disabled="currentPage === 1">上一页</button>
                      <span class="pagination-info">
                        {{ currentPage }} / {{ totalPages }}
                      </span>
                      <button @click="nextPage" :disabled="currentPage === totalPages">下一页</button>
                      <span class="pagination-info">共 {{ total }} 条</span>
                    </div>
                  </div>
                </div>
                <!-- 上半部分：自动播放的圆环饼图 -->
                <div class="top-chart-section">
                  <div class="ring-grid">
                    <div
                        class="ring-card"
                        v-for="(item, idx) in ringChartData"
                        :key="idx"
                        :style="{
                        '--card-color': item.color,
                        backgroundImage: item.bg ? `url(${item.bg})` : 'none'
                      }"
                    >
                      <div class="ring-card-header">
                        <div class="header-title-wrapper">
                          <div class="title-icon">
                            <img :src="item.icon" alt="icon" style="width: 100%; height: 100%;object-fit: contain;"/>
                          </div>
                          <div class="title-content">
                            <div class="ring-card-name" :style="{ color: item.color }">{{ item.name }}</div>
                            <div class="ring-card-subtitle">{{ item.subtitle }}</div>
                          </div>
                        </div>
                      </div>
                      <div class="ring-chart-container">
                        <Echart
                            :options="getSingleRingOptions(item, idx)"
                            :id="`RingChart_${idx}`"
                            height="100%"
                            width="100%"
                        ></Echart>
                        <div class="chart-center-info">
                          <div class="center-value">
                            <span class="value-number">{{ animatedRingValues[idx] }}</span>
                            <span
                                v-if="activeRingMetrics[idx] && activeRingMetrics[idx].unit"
                                class="value-unit"
                            >{{ activeRingMetrics[idx].unit }}</span>
                          </div>
                          <div
                              class="center-name"
                              v-if="activeRingMetrics[idx]"
                          >
                            {{ activeRingMetrics[idx].name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="legend-list">
                    <div
                      class="legend-item"
                      v-for="(item, idx) in ringChartData"
                      :key="idx"
                    >
                      <div class="legend-value">
                        <span class="legend-number">{{ animatedRingValues[idx] }}</span>
                        <span
                          v-if="activeRingMetrics[idx] && activeRingMetrics[idx].unit"
                          class="legend-unit"
                        >
                          {{ activeRingMetrics[idx].unit }}
                        </span>
                      </div>
                      <div
                        class="legend-name"
                        v-if="activeRingMetrics[idx]"
                      >
                        {{ activeRingMetrics[idx].name }}
                      </div>
                      <div class="legend-chain">{{ item.name }}</div>
                    </div>
                  </div> -->
                </div>

                <!-- 下半部分：两个折线图 -->
                <div class="bottom-charts-section">
                  <div class="bar-charts-wrapper">
                    <!-- 第一个折线图 -->
                    <div class="bar-chart-item">
                      <div class="chart-title">技能型人才增长趋势(2019-2025)</div>
                      <Echart
                          :options="areaChart1Options"
                          id="AreaChart1"
                          height="100%"
                          width="100%"
                      ></Echart>
                    </div>
                    <!-- 第二个折线图 -->
                    <div class="bar-chart-item">
                      <div class="chart-title">工资增长趋势(2019-2025)</div>
                      <Echart
                          :options="areaChart2Options"
                          id="AreaChart2"
                          height="100%"
                          width="100%"
                      ></Echart>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 右侧区域 -->
              <div class="right-section">
                <!-- 数据统计卡片 -->
                <div class="data-cards">
                  <div
                      v-for="(item, index) in statisticsData"
                      :key="index"
                      class="data-card"
                      :class="{
                      'laomo-card': item.label === '劳模',
                      'gongjiang-card': item.label === '工匠',
                      'wuyi-jiangzhuang-card': item.label === '五一奖状',
                      'wuyi-jiangzhang-card': item.label === '五一奖章',
                      'chuangxin-nengshou-card': item.label === '创新能手',
                      'gongren-xianfenghao-card': item.label === '工人先锋号',
                      'jinpai-gongren-card': item.label === '金牌工人',
                      'wenming-zhigong-card': item.label === '文明职工'
                    }"
                      @click="handleCardClick(item)"
                  >
                    <div class="card-icon">
                      <img v-if="item.icon" :src="item.icon" :alt="item.label"/>
                    </div>
                    <div class="card-value">{{ item.value }}</div>
                    <div class="card-label">{{ item.label }}</div>
                  </div>
                </div>

                <!-- 数据列表覆盖层 -->
                <div v-if="showDataList" class="data-list-overlay" @click.self="closeDataList">
                  <div class="data-list-container">
                    <div class="data-list-header">
                      <h3>{{ selectedCard?.label || '' }} 列表</h3>
                      <button class="close-btn" @click="closeDataList">×</button>
                    </div>
                    <div class="data-list-content">
                      <!-- 动态生成的数据表格 -->
                      <table v-if="currentData.length > 0" class="data-table">
                        <thead>
                        <tr>
                          <th v-for="column in getTableColumns(selectedCard?.label)" :key="column.key">
                            {{ column.title }}
                          </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in paginatedData" :key="index">
                          <td v-for="column in getTableColumns(selectedCard?.label)" :key="column.key">
                            {{ item[column.key] }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <div v-else class="empty-message">暂无数据</div>
                    </div>
                    <div class="pagination">
                      <button
                          @click="prevPage"
                          :disabled="pagination.currentPage === 1"
                      >
                        上一页
                      </button>

                      <span
                          v-for="page in pageRange"
                          :key="page"
                          class="page-number"
                          :class="{ active: page === pagination.currentPage }"
                          @click="handlePageChange(page)"
                      >
                          {{ page }}
                        </span>

                      <button
                          @click="nextPage"
                          :disabled="pagination.currentPage === totalPages || totalPages === 0"
                      >
                        下一页
                      </button>


                    </div>
                  </div>
                </div>

                <!-- 轮播图区域 -->
                <div class="carousel-section">
                  <div class="carousel-container">
                    <div class="carousel-image">
                      <img :src="carouselData[currentCarouselIndex].image"
                           :alt="carouselData[currentCarouselIndex].name"/>
                    </div>
                    <div class="carousel-info">
                      <div class="carousel-company">{{ carouselData[currentCarouselIndex].company }}</div>
                    </div>
                  </div>
                  <!-- 轮播指示器 -->
                  <div class="carousel-dots">
                    <div class="carousel-title-label">{{ carouselData[currentCarouselIndex].title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Footer 组件 -->
          <div class="footer-container">
            <PageFooter/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from '../utils/drawMixin'
import PageHeader from '@/components/page-header/index.vue'
import {get} from "@/utils/request";
import PageFooter from "_c/page-footer/index.vue";

export default {
  name: 'Insight',
  mixins: [drawMixin],
  components: {
    PageFooter,
    PageHeader,
  },
  data() {
    return {
      VUE_APP_API_BASE_URL: "https://dp.houkongfan.cn",
      loading: false,
      showDataList: false,
      selectedCard: null,
      currentData: [],
      // 分页相关状态
      pagination: {
        currentPage: 1,
        pageSize: 14,
        total: 0
      },
      // 模拟数据
      mockData: {
        '劳模': [],
        '工匠': [],
        '五一奖状': [],
        '五一奖章': [],
        '创新能手': [],
        '工人先锋号': [],
        '金牌工人': [],
        '文明职工': []
      },
      // 圆环图数据
      ringChartData: [
        {
          name: '高端装备产业链',
          subtitle: '权益共护',
          color: '#b8e5fe', // 亮蓝色
          icon: require('@/assets/page3/1762090144778-q1QPEax-.png'), // 可以替换成图片URL
          bg: require('@/assets/page3/1762096973459-T1qwaQp2.png'),
          metrics: [
            {name: '职工人数', value: 11987, unit: '人', color: '#ffffff'},
            {name: '技能人才', value: 3125, unit: '人', color: '#69bbff'},
            {name: '党员人数', value: 2812, unit: '人', color: '#bd9cff'},
            {name: '专利数', value: 1850, unit: '项', color: '#ff7fd0'},
            {name: '两代表一委', value: 72, unit: '人', color: '#e7bbff'},
          ],
        },
        {
          name: '智能制造产业链',
          subtitle: '产教融合',
          color: '#b8e5fe', // 青绿色
          icon: require('@/assets/page3/1762090194132-59yiDQo4.png'), // 可以替换成图片URL
          bg: require('@/assets/page3/1762097100485-6T93II_L.png'),
          metrics: [
            {name: '教职工人数', value: 5475, unit: '人', color: '#ffffff'},
            {name: '技能人才', value: 1795, unit: '人', color: '#69bbff'},
            {name: '党员人数', value: 815, unit: '人', color: '#bd9cff'},
            {name: '专利数', value: 950, unit: '项', color: '#ccbbff'},
            {name: '两代表一委', value: 49, unit: '人', color: '#ff7fd0'},
          ],
        },
        {
          name: '高端纺织产业链',
          subtitle: '高端装备',
          color: '#b8e5fe', // 金黄色
          icon: require('@/assets/page3/1762090274658-1e0ZNq19.png'), // 可以替换成图片URL
          bg: require('@/assets/page3/1762097291723-WX7W-Xrm.png'),
          metrics: [
            {name: '职工人数', value: 5213, unit: '人', color: '#ffffff'},
            {name: '技能人才', value: 1502, unit: '人', color: '#edffff'},
            {name: '党员人数', value: 465, unit: '人', color: '#5f55ff'},
            {name: '专利数', value: 1200, unit: '项', color: '#ccbbff'},
            {name: '两代表一委', value: 31, unit: '人', color: '#e7bbff'},
          ],
        },
        {
          name: '大快消产业链',
          subtitle: '职享生活',
          color: '#b8e5fe', // 粉红色
          icon: require('@/assets/page3/1762090345566-0FNn6c2t.png'), // 可以替换成图片URL
          bg: require('@/assets/page3/1762097278631-zg0JHk7h.png'),
          metrics: [
            {name: '职工人数', value: 3300, unit: '人', color: '#ffffff'},
            {name: '技能人才', value: 312, unit: '人', color: '#edffff'},
            {name: '党员人数', value: 298, unit: '人', color: '#5f55ff'},
            {name: '专利数', value: 915, unit: '项', color: '#ccbbff'},
            {name: '两代表一委', value: 21, unit: '人', color: '#e7bbff'},
          ],
        },
      ],
      // 折线图1数据（技能型人才增长趋势 2019-2025）
      areaChart1Data: {
        years: [],
        series: [
          {name: '高端装备', color: '#00a9ff', data: []},
          {name: '智能制造', color: '#00e0be', data: []},
          {name: '高端纺织', color: '#ffcc00', data: []},
          {name: '大快消', color: '#ff5218', data: []},
        ],
      },
      // 折线图2数据（工资增长趋势 2019-2025）
      areaChart2Data: {
        years: [],
        series: [
          {name: '高端装备', color: '#00a9ff', data: []},
          {name: '智能制造', color: '#00e0be', data: []},
          {name: '高端纺织', color: '#ffcc00', data: []},
          {name: '大快消', color: '#ff5218', data: []},
        ],
      },
      // 荣誉墙统计数据
      statisticsData: [],
      // 轮播图数据
      carouselData: [],
      currentCarouselIndex: 0, // 当前轮播图索引
      carouselTimer: null, // 轮播图定时器
      animatedRingValues: [], // 各卡片中心动画值
      ringActiveMetricIndexes: [], // 各卡片当前展示的指标索引
      ringAnimationFrames: {}, // 各卡片动画帧
      ringTimer: null, // 四卡自动播放定时器
    }
  },
  watch: {},

  methods: {
    async onLoadInfo() {
      this.loading = true
      const url = this.VUE_APP_API_BASE_URL + "/dev-api/system/page3/queryList"
      const result = await get(url)
      if (result.success) {
        // 处理产业链数据 (cylList)
        if (result.data.cylList && result.data.cylList.length > 0) {
          // 更新圆环图数据
          this.ringChartData = result.data.cylList.map((item, index) => {
            // 保持原有的图标、背景等样式信息
            const originalItem = this.ringChartData[index] || this.ringChartData[0];

            return {
              name: item.cylname,
              subtitle: item.cyldesc,
              color: originalItem?.color || '#b8e5fe',
              icon: originalItem?.icon || '',
              bg: originalItem?.bg || '',
              metrics: [
                {name: '职工人数', value: item.zgrsNum, unit: '人', color: '#ffffff'},
                {name: '技能人才', value: item.jnrcNum, unit: '人', color: '#69bbff'},
                {name: '党员人数', value: item.dyrsNum, unit: '人', color: '#bd9cff'},
                {name: '专利数', value: item.zlsNum, unit: '项', color: '#ff7fd0'},
                {name: '两代表一委', value: item.ldbywNum, unit: '人', color: '#e7bbff'},
              ],
            }
          });

          //荣誉墙
          const ryqData = result.data.ryqlist
          this.statisticsData = [
            {
              label: '劳模',
              value: ryqData.lbList.length,
              icon: require('@/assets/page3/1762863310129-MLz6Kv3o.png'),
              color: '#00d9ff'
            },
            {
              label: '工匠',
              value: ryqData.gjList.length,
              icon: require('@/assets/page3/1762863307150-ca9fptlG.png'),
              color: '#ffc000'
            },
            {
              label: '五一奖状',
              value: ryqData.wyjzList.length,
              icon: require('@/assets/page3/1762863299853-GFUSNL8a.png'),
              color: '#ff6b9d'
            },
            {
              label: '五一奖章',
              value: ryqData.wyjzList2.length,
              icon: require('@/assets/page3/1762863295466-u4ZHgggu.png'),
              color: '#ff6b9d'
            },
            {
              label: '创新能手',
              value: ryqData.cjnsList.length,
              icon: require('@/assets/page3/1762863292342-Qi820qZO.png'),
              color: '#00d9ff'
            },
            {
              label: '工人先锋号',
              value: ryqData.grxfhList.length,
              icon: require('@/assets/page3/1762863289326-sqFIX8QT.png'),
              color: '#c77bff'
            },
            {
              label: '金牌工人',
              value: ryqData.jpgrList.length,
              icon: require('@/assets/page3/1762863285754-o5ho11ub.png'),
              color: '#ffc000'
            },
            {
              label: '文明职工',
              value: ryqData.wmzgList.length,
              icon: require('@/assets/page3/1762863279274-4zAA05qy.png'),
              color: '#00d9ff'
            },
          ]

          //封装每个分页的数据
          this.mockData = {
            '劳模': ryqData.lbList.map((item, index) => ({
              id: index + 1,
              unit: item.dwname, // 需要从实际数据中获取单位信息
              name: item.name, // 需要从实际数据中获取姓名信息
              honor: item.ry,
              honorTitle: item.rych, // 需要从实际数据中获取荣誉称号
              honorTime: item.rhsj,  // 需要从实际数据中获取时间
              honorLevel: item.ryjb  // 需要从实际数据中获取级别
            })),
            '工匠': ryqData.gjList.map((item, index) => ({
              id: index + 1,
              unit: item.dwname, // 需要从实际数据中获取单位信息
              name: item.name, // 需要从实际数据中获取姓名信息
              honor: item.ry,
            })),
            '五一奖状': ryqData.wyjzList.map((item, index) => ({
              id: index + 1,
              unit: item.dwname, // 需要从实际数据中获取单位信息
              name: item.name, // 需要从实际数据中获取姓名信息
              honor: item.ry,
              honorTitle: item.rych, // 需要从实际数据中获取荣誉称号
              honorTime: item.rhsj,  // 需要从实际数据中获取时间
              honorLevel: item.ryjb  // 需要从实际数据中获取级别
            })),
            '五一奖章': ryqData.wyjzList2.map((item, index) => ({
              id: index + 1,
              unit: item.dwname, // 需要从实际数据中获取单位信息
              name: item.name, // 需要从实际数据中获取姓名信息
              honor: item.ry,
              honorTitle: item.rych, // 需要从实际数据中获取荣誉称号
              honorTime: item.rhsj,  // 需要从实际数据中获取时间
              honorLevel: item.ryjb  // 需要从实际数据中获取级别
            })),
            '创新能手': ryqData.cjnsList.map((item, index) => ({
              id: index + 1,
              unit: item.dwname, // 需要从实际数据中获取单位信息
              name: item.name, // 需要从实际数据中获取姓名信息
            })),
            '工人先锋号': ryqData.grxfhList.map((item, index) => ({
              id: index + 1,
              unit: item.dwname, // 需要从实际数据中获取单位信息
              name: item.name, // 需要从实际数据中获取姓名信息
              honor: item.ry,
              honorTitle: item.rych, // 需要从实际数据中获取荣誉称号
              honorTime: item.rhsj,  // 需要从实际数据中获取时间
              honorLevel: item.ryjb  // 需要从实际数据中获取级别
            })),
            '金牌工人': ryqData.jpgrList.map((item, index) => ({
              id: index + 1,
              unit: item.dwname, // 需要从实际数据中获取单位信息
              name: item.name, // 需要从实际数据中获取姓名信息
              honor: item.ry,
              honorTitle: item.rych, // 需要从实际数据中获取荣誉称号
              honorTime: item.rhsj,  // 需要从实际数据中获取时间
              honorLevel: item.ryjb  // 需要从实际数据中获取级别
            })),
            '文明职工': ryqData.wmzgList.map((item, index) => ({
              id: index + 1,
              unit: item.dwname, // 需要从实际数据中获取单位信息
              name: item.name, // 需要从实际数据中获取姓名信息
              honor: item.ry,
              honorTitle: item.rych, // 需要从实际数据中获取荣誉称号
              honorTime: item.rhsj,  // 需要从实际数据中获取时间
              honorLevel: item.ryjb  // 需要从实际数据中获取级别
            })),
          };


          //渲染折线图数据
          const dkxzczList = result.data.dkxzczList
          const gdfzzczList = result.data.gdfzzczList
          const znzzzczList = result.data.znzzzczList
          const gdzbzczList = result.data.gdzbzczList

          // 使用统一的年份数据（以其中一个为准，或合并去重）
          this.areaChart1Data.years = dkxzczList.dkxyears || []
          this.areaChart2Data.years = dkxzczList.dkxyears || []

          // 按照正确的顺序赋值数据
          this.areaChart1Data.series[0].data = gdzbzczList.gdzbzczList || []  // 高端装备
          this.areaChart1Data.series[1].data = znzzzczList.znzzzczList || []  // 智能制造
          this.areaChart1Data.series[2].data = gdfzzczList.gdfzzczList || []  // 高端纺织
          this.areaChart1Data.series[3].data = dkxzczList.dkxzczList || []  // 大快消

          // 工资增长趋势数据
          this.areaChart2Data.series[0].data = gdzbzczList.gdzbzcz1List || []  // 高端装备
          this.areaChart2Data.series[1].data = znzzzczList.znzzzcz1List || []  // 智能制造
          this.areaChart2Data.series[2].data = gdfzzczList.gdfzzcz1List || []  // 高端纺织
          this.areaChart2Data.series[3].data = dkxzczList.dkxzcz1List || []  // 大快消

          //加载先进代表信息
          const xjdbData = result.data.xjdbList
          this.carouselData = xjdbData.map((item) => ({
            name: item.name,
            company: item.company,
            title: item.title,
            image: this.VUE_APP_API_BASE_URL + `/dev-api` + item.imgurl
          }));
        }
      }
      this.loading = false
    },

    // 处理卡片点击事件
    handleCardClick(card) {
      this.selectedCard = card;
      this.showDataList = true;
      // 重置页码
      this.pagination.currentPage = 1;
      // 加载对应标签的数据
      this.loadDataByLabel(card.label);
    },

    // 关闭数据列表
    closeDataList() {
      this.showDataList = false;
      this.selectedCard = null;
      this.currentData = [];
      this.pagination.currentPage = 1;
      this.pagination.total = 0;
    },

    // 根据标签加载数据
    loadDataByLabel(label) {
      const allData = this.mockData[label] || [];
      this.pagination.total = allData.length;
      this.currentData = allData;
    },

    // 分页相关方法
    handlePageChange(page) {
      this.pagination.currentPage = page;
    },

    handlePageSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
    },

    // 上一页
    prevPage() {
      if (this.pagination.currentPage > 1) {
        this.pagination.currentPage--;
      }
    },

    // 下一页
    nextPage() {
      if (this.pagination.currentPage < this.totalPages) {
        this.pagination.currentPage++;
      }
    },

    // 根据标签获取表格列配置
    getTableColumns(label) {
      const columnsMap = {
        '劳模': [
          {key: 'id', title: '序号'},
          {key: 'unit', title: '单位'},
          {key: 'name', title: '姓名'},
          {key: 'honor', title: '荣誉'},
          {key: 'honorTitle', title: '荣誉称号'},
          {key: 'honorTime', title: '荣获时间'},
          {key: 'honorLevel', title: '荣誉级别'}
        ],
        '工匠': [
          {key: 'id', title: '序号'},
          {key: 'unit', title: '单位/城市'},
          {key: 'name', title: '姓名'},
          {key: 'honor', title: '荣誉'}
        ],
        '五一奖状': [
          {key: 'id', title: '序号'},
          {key: 'unit', title: '单位'},
        ],
        '五一奖章': [
          {key: 'id', title: '序号'},
          {key: 'unit', title: '单位'},
          {key: 'name', title: '姓名'},
        ],
        '创新能手': [
          {key: 'id', title: '序号'},
          {key: 'unit', title: '单位'},
          {key: 'name', title: '姓名'},
        ],
        '工人先锋号': [
          {key: 'id', title: '序号'},
          {key: 'unit', title: '集体/单位'},
          {key: 'honor', title: '荣誉'}
        ],
        '金牌工人': [
          {key: 'id', title: '序号'},
          {key: 'unit', title: '单位'},
          {key: 'name', title: '姓名'},
        ],
        '文明职工': [
          {key: 'id', title: '序号'},
          {key: 'unit', title: '单位'},
          {key: 'name', title: '姓名'},
          {key: 'honor', title: '荣誉'}
        ]
      };

      // 对于其他标签，使用通用的城市+荣誉结构
      if (!columnsMap[label]) {
        return [
          {key: 'id', title: '序号'},
          {key: 'city', title: '城市'},
          {key: 'honor', title: '荣誉'}
        ];
      }

      return columnsMap[label];
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 单个环卡片的配置
    getSingleRingOptions(item, idx) {
      const metrics = item.metrics || []
      const activeIndex = this.ringActiveMetricIndexes[idx] ?? 0
      return {
        backgroundColor: 'transparent',
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          borderColor: '#00d9ff',
          borderWidth: 1,
          textStyle: {color: '#fff'},
          formatter: (params) => {
            const metric = metrics[params.dataIndex] || {}
            const unit = metric.unit ? ` ${metric.unit}` : ''
            return `${params.marker}${params.name}<br/>${metric.value}${unit}`
          },
        },
        legend: {
          show: true,
          left: 'center',
          bottom: '5%',
          orient: 'horizontal',
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 15,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['55%', '75%'],
            center: ['50%', '40%'],
            hoverAnimation: false,
            selectedMode: 'single',
            selectedOffset: 12,
            avoidLabelOverlap: true,
            label: {show: false},
            labelLine: {show: false},
            data: metrics.map((metric, metricIdx) => ({
              value: metric.value,
              name: metric.name,
              selected: metricIdx === activeIndex,
              itemStyle: {
                color: metric.color,
                opacity: 1,
                shadowBlur: metricIdx === activeIndex ? 12 : 0,
                shadowColor: metricIdx === activeIndex ? 'rgba(0, 217, 255, 0.45)' : 'transparent',
                borderWidth: metricIdx === activeIndex ? 2 : 0,
                borderColor: metricIdx === activeIndex ? '#00121f' : 'transparent',
              },
              emphasis: {disabled: true},
            })),
          },
        ],
      }
    },
    // 轮播图自动播放
    startCarouselAutoPlay() {
      this.carouselTimer = setInterval(() => {
        this.currentCarouselIndex = (this.currentCarouselIndex + 1) % this.carouselData.length
      }, 4000)
    },
    stopCarouselAutoPlay() {
      if (this.carouselTimer) {
        clearInterval(this.carouselTimer)
        this.carouselTimer = null
      }
    },
    // 手动切换轮播图
    switchCarousel(index) {
      this.currentCarouselIndex = index
      this.stopCarouselAutoPlay()
      this.startCarouselAutoPlay()
    },
    setRingMetric(idx, metricIndex, immediate = false, resetFromZero = false) {
      const metrics = (this.ringChartData[idx] && this.ringChartData[idx].metrics) || []
      if (!metrics.length) {
        return
      }
      const safeIndex = ((metricIndex % metrics.length) + metrics.length) % metrics.length
      const metric = metrics[safeIndex]
      this.$set(this.ringActiveMetricIndexes, idx, safeIndex)
      this.animateRingValueFor(idx, metric.value, immediate, resetFromZero)
    },
    animateRingValueFor(index, target, immediate = false, resetFromZero = false) {
      if (typeof target !== 'number') {
        return
      }
      const startValue = resetFromZero ? 0 : (this.animatedRingValues[index] || 0)
      const duration = 800
      if (immediate) {
        this.$set(this.animatedRingValues, index, Math.round(target))
        this.cancelRingAnimation(index)
        return
      }
      this.cancelRingAnimation(index)
      const startTime = performance.now()
      const animate = (now) => {
        const elapsed = now - startTime
        const progress = Math.min(elapsed / duration, 1)
        const eased = 1 - Math.pow(1 - progress, 3)
        this.$set(this.animatedRingValues, index, Math.round(startValue + (target - startValue) * eased))
        if (progress < 1) {
          this.ringAnimationFrames[index] = requestAnimationFrame(animate)
        } else {
          this.ringAnimationFrames[index] = null
        }
      }
      this.ringAnimationFrames[index] = requestAnimationFrame(animate)
    },
    cancelRingAnimation(index) {
      const frame = this.ringAnimationFrames[index]
      if (frame) {
        cancelAnimationFrame(frame)
        this.ringAnimationFrames[index] = null
      }
    },
    cancelAllRingAnimations() {
      Object.keys(this.ringAnimationFrames).forEach((k) => {
        const idx = Number(k)
        this.cancelRingAnimation(idx)
      })
    },
    playAllRingAnimations({cycle = true, resetFromZero = false} = {}) {
      this.ringChartData.forEach((item, idx) => {
        const metrics = item.metrics || []
        if (!metrics.length) {
          return
        }
        const currentIndex = this.ringActiveMetricIndexes[idx] ?? 0
        const targetIndex = cycle ? (currentIndex + 1) % metrics.length : currentIndex
        this.setRingMetric(idx, targetIndex, false, resetFromZero)
      })
    },
    startRingAutoPlay() {
      this.stopRingAutoPlay()
      this.ringTimer = setInterval(() => {
        this.playAllRingAnimations()
      }, 3200)
    },
    stopRingAutoPlay() {
      if (this.ringTimer) {
        clearInterval(this.ringTimer)
        this.ringTimer = null
      }
    },
  },
  computed: {
    tableColumns() {
      const label = this.selectedCard && this.selectedCard.label ? this.selectedCard.label : ''
      return this.getTableColumns(label)
    },
    currentPage() {
      return this.pagination.currentPage
    },
    total() {
      return this.pagination.total
    },
    // 分页相关计算属性
    totalPages() {
      return Math.ceil(this.pagination.total / this.pagination.pageSize);
    },

    // 当前页显示的数据
    paginatedData() {
      const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
      const end = start + this.pagination.pageSize;
      return this.currentData.slice(start, end);
    },

    // 页码范围（显示的页码数量限制为5个）
    pageRange() {
      const total = this.totalPages;
      const current = this.pagination.currentPage;
      const range = [];

      if (total <= 5) {
        // 如果总页数小于等于5，显示所有页码
        for (let i = 1; i <= total; i++) {
          range.push(i);
        }
      } else {
        // 如果总页数大于5，显示当前页附近的页码
        if (current <= 3) {
          // 当前页在前三页
          for (let i = 1; i <= 5; i++) {
            range.push(i);
          }
        } else if (current >= total - 2) {
          // 当前页在后三页
          for (let i = total - 4; i <= total; i++) {
            range.push(i);
          }
        } else {
          // 当前页在中间
          for (let i = current - 2; i <= current + 2; i++) {
            range.push(i);
          }
        }
      }

      return range;
    },

    singleRingMax() {
      // 计算用于显示比例的最大值
      const values = this.ringChartData.flatMap(item =>
          (item.metrics || []).map(metric => metric.value)
      )
      return values.length ? Math.max(...values) : 0
    },
    activeRingMetrics() {
      return this.ringChartData.map((item, idx) => {
        const metrics = item.metrics || []
        const activeIndex = this.ringActiveMetricIndexes[idx] ?? 0
        return metrics[activeIndex] || null
      })
    },
    // 折线图1配置（技能型人才增长趋势）
    areaChart1Options() {
      // 按照数据的最大值从小到大排序，确保数值大的系列显示在上层（堆叠图中数组后面的元素在上层）
      const sortedSeries = [...this.areaChart1Data.series].sort((a, b) => {
        const aMaxValue = Math.max(...a.data)
        const bMaxValue = Math.max(...b.data)
        return aMaxValue - bMaxValue
      })
      const legendData = sortedSeries.map(item => item.name)

      // 将hex颜色转换为半透明rgba
      const hexToRgba = (hex, alpha) => {
        const r = parseInt(hex.slice(1, 3), 16)
        const g = parseInt(hex.slice(3, 5), 16)
        const b = parseInt(hex.slice(5, 7), 16)
        return `rgba(${r}, ${g}, ${b}, ${alpha})`
      }

      return {
        backgroundColor: 'transparent',
        grid: {
          left: '8%',
          right: '5%',
          top: '20%',
          bottom: '15%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#00d9ff',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.5)',
            },
          },
        },
        legend: {
          top: '5%',
          left: 'center',
          data: legendData,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
          itemWidth: 14,
          itemHeight: 10,
          icon: 'circle',
          // 过滤掉基线系列
          selectedMode: false,
        },
        xAxis: {
          type: 'category',
          data: this.areaChart1Data.years,
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.3)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#6b7d8f',
            fontSize: 11,
          },
        },
        yAxis: {
          type: 'value',
          name: '人',
          nameTextStyle: {
            color: '#6b7d8f',
            fontSize: 12,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#fff',
            fontSize: 11,
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.1)',
              type: 'dashed',
            },
          },
        },
        series: sortedSeries.flatMap((item, itemIndex) => {
          // 计算每个数据点对应的下一条线的y值（基线）
          const baselineData = item.data.map((value, dataIndex) => {
            // 找到在当前x轴位置，y值小于当前值且最大的那条线的y值
            let maxLowerValue = 0
            for (let i = 0; i < sortedSeries.length; i++) {
              if (i !== itemIndex) {
                const otherValue = sortedSeries[i].data[dataIndex]
                if (otherValue < value && otherValue > maxLowerValue) {
                  maxLowerValue = otherValue
                }
              }
            }
            return maxLowerValue
          })

          // 计算主系列的数据（当前值减去基线值）
          const mainData = item.data.map((value, index) => value - baselineData[index])

          return [
            // 基线系列（不可见，用于堆叠）
            {
              name: `${item.name}_baseline`,
              type: 'line',
              stack: `area-${itemIndex}`,
              data: baselineData,
              lineStyle: {
                opacity: 0
              },
              itemStyle: {
                opacity: 0
              },
              areaStyle: {
                opacity: 0
              },
              silent: true
            },
            // 主系列（可见，堆叠在基线上）
            {
              name: item.name,
              type: 'line',
              stack: `area-${itemIndex}`,
              smooth: true,
              lineStyle: {
                width: 0,
              },
              showSymbol: true,
              symbol: 'circle',
              symbolSize: 4,
              itemStyle: {
                color: item.color,
              },
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {offset: 0, color: item.color},
                    {offset: 1, color: hexToRgba(item.color, 0.4)}
                  ]
                }
              },
              emphasis: {
                focus: 'series',
              },
              data: mainData,
              label: {
                show: true,
                position: 'top',
                fontSize: 10,
                color: item.name === '大快消' ? '#fff' : item.color,
                formatter: (params) => {
                  // 显示原始值（基线值 + 当前值）
                  const originalValue = baselineData[params.dataIndex] + params.value
                  return originalValue
                },
              },
            }
          ]
        }),
      }
    },
    // 折线图2配置（工资增长趋势）
    areaChart2Options() {
      // 将hex颜色转换为半透明rgba
      const hexToRgba = (hex, alpha) => {
        const r = parseInt(hex.slice(1, 3), 16)
        const g = parseInt(hex.slice(3, 5), 16)
        const b = parseInt(hex.slice(5, 7), 16)
        return `rgba(${r}, ${g}, ${b}, ${alpha})`
      }

      // 按照数据的最大值从小到大排序，确保数值大的系列显示在上层
      const sortedSeries = [...this.areaChart2Data.series].sort((a, b) => {
        const aMaxValue = Math.max(...a.data)
        const bMaxValue = Math.max(...b.data)
        return aMaxValue - bMaxValue
      })
      const legendData = sortedSeries.map(item => item.name)

      return {
        backgroundColor: 'transparent',
        grid: {
          left: '8%',
          right: '5%',
          top: '20%',
          bottom: '15%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#00d9ff',
          borderWidth: 1,
          textStyle: {
            color: '#fff',
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.5)',
            },
          },
        },
        legend: {
          top: '5%',
          left: 'center',
          data: legendData,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
          itemWidth: 14,
          itemHeight: 10,
          icon: 'circle',
          selectedMode: false,
        },
        xAxis: {
          type: 'category',
          data: this.areaChart2Data.years,
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.3)',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#6b7d8f',
            fontSize: 11,
          },
        },
        yAxis: {
          type: 'value',
          name: '万元',
          nameTextStyle: {
            color: '#6b7d8f',
            fontSize: 12,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#fff',
            fontSize: 11,
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(0, 217, 255, 0.1)',
              type: 'dashed',
            },
          },
        },
        series: sortedSeries.flatMap((item, itemIndex) => {
          // 计算每个数据点对应的下一条线的y值（基线）
          const baselineData = item.data.map((value, dataIndex) => {
            // 找到在当前x轴位置，y值小于当前值且最大的那条线的y值
            let maxLowerValue = 0
            for (let i = 0; i < sortedSeries.length; i++) {
              if (i !== itemIndex) {
                const otherValue = sortedSeries[i].data[dataIndex]
                if (otherValue < value && otherValue > maxLowerValue) {
                  maxLowerValue = otherValue
                }
              }
            }
            return maxLowerValue
          })

          // 计算主系列的数据（当前值减去基线值）
          const mainData = item.data.map((value, index) => value - baselineData[index])

          return [
            // 基线系列（不可见，用于堆叠）
            {
              name: `${item.name}_baseline`,
              type: 'line',
              stack: `area2-${itemIndex}`,
              data: baselineData,
              lineStyle: {
                opacity: 0
              },
              itemStyle: {
                opacity: 0
              },
              areaStyle: {
                opacity: 0
              },
              silent: true
            },
            // 主系列（可见，堆叠在基线上）
            {
              name: item.name,
              type: 'line',
              stack: `area2-${itemIndex}`,
              smooth: true,
              lineStyle: {
                width: 0,
              },
              showSymbol: true,
              symbol: 'circle',
              symbolSize: 4,
              itemStyle: {
                color: item.color,
              },
              areaStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {offset: 0, color: item.color},
                    {offset: 1, color: hexToRgba(item.color, 0.1)}
                  ]
                }
              },
              emphasis: {
                focus: 'series',
              },
              data: mainData,
              label: {
                show: true,
                position: 'top',
                fontSize: 10,
                color: item.name === '大快消' ? '#fff' : item.color,
                formatter: (params) => {
                  // 显示原始值（基线值 + 当前值）
                  const originalValue = baselineData[params.dataIndex] + params.value
                  return originalValue
                },
              },
            }
          ]
        }),
      }
    },
  },
  mounted() {
    this.onLoadInfo();
    this.cancelLoading()
    this.startCarouselAutoPlay()
    // 初始化四个卡片的数字动画为目标值
    this.animatedRingValues = this.ringChartData.map(() => 0)
    this.ringActiveMetricIndexes = this.ringChartData.map(() => 0)
    this.$nextTick(() => {
      this.playAllRingAnimations({cycle: false, resetFromZero: true})
      this.startRingAutoPlay()
    })
    this.$nextTick(() => {
      setTimeout(() => {
        this.calcRate()
      }, 600)
    })
  },
  beforeDestroy() {
    this.stopCarouselAutoPlay()
    this.cancelAllRingAnimations()
    this.stopRingAutoPlay()
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/index.scss';

#index {
  color: #d3d6dd;
  width: 1920px;
  height: 1080px;
  position: fixed;
  left: 0;
  top: 0;
  transform-origin: left top;
  overflow: hidden;

  .bg {
    width: 100%;
    min-height: 100%;
    padding: 16px 16px 20px 16px;
    background-image: url('../assets/bj.jpg');
    background-size: cover;
    background-position: center center;
  }

  .footer-container {
    position: absolute;
    bottom: -8px;
    left: 0;
    right: 0;
  }

  .bg-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.3;
    z-index: 0;
    pointer-events: none;
  }

  .host-body {
    .center {
      width: 100%;
      margin-top: 10px;
    }

    .main-content {
      width: 100%;
      padding: 20px;


    }

    .content-layout {
      display: flex;
      gap: 20px;
      width: 100%;
      height: calc(1080px - 70px - 10px - 32px - 40px); // 总高度1080 - header 70 - center的margin-top 10 - bg的padding 32 - main-content的padding 40
      // 也就是 928px
    }

    // 左侧区域
    .left-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;
      min-width: 0;

      // 上半部分：圆环图
      .top-chart-section {
        flex: 1;
        min-height: 0;
        background: rgba(7, 20, 36, 0.45);
        border: 1px solid rgba(0, 217, 255, 0.2);
        border-radius: 8px;
        padding: 20px;
        display: flex;
        flex-direction: column;

        .section-title {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 20px;
          padding-bottom: 10px;
          border-bottom: 1px solid rgba(0, 217, 255, 0.2);

          .title-icon {
            font-size: 24px;
          }

          .title-text {
            font-size: 20px;
            font-weight: 600;
            color: #00d9ff;
          }
        }

        .ring-chart-container {
          position: relative;
          flex: 1;
          min-height: 310px;

          .chart-center-info {
            position: absolute;
            top: 45%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            pointer-events: none;
            z-index: 10;

            .center-value {
              font-size: 36px;
              font-weight: 700;
              color: #00d9ff;
              line-height: 1.2;
              display: flex;
              align-items: baseline;
              justify-content: center;
              gap: 4px;

              .value-number {
                font-size: 38px;
              }

              .value-unit {
                font-size: 14px;
                color: #6b7d8f;
              }
            }

            .center-name {
              font-size: 13px;
              color: #8fa4b9;
              margin-top: 4px;
            }
          }
        }

        .ring-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
          margin-bottom: 20px;
          width: 100%;
        }

        .ring-card {
          background-repeat: no-repeat;
          background-position: center center;
          background-size: 100% 100%;
          padding: 12px;
          display: flex;
          flex-direction: column;
          min-height: 320px;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;


          .ring-card-header {
            margin-bottom: 8px;

            .header-title-wrapper {
              display: flex;
              align-items: center;
              gap: 10px;
              padding: 8px 12px;
              border: 1px solid rgba(0, 150, 255, 0.25); // 统一的淡蓝色边框
              border-radius: 0 12px 0 12px; // 右上角和左下角圆角
              background: rgba(0, 80, 150, 0.08); // 统一的淡淡蓝色背景
              backdrop-filter: blur(10px);
              position: relative;
              overflow: hidden;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

              &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: linear-gradient(135deg, rgba(255, 255, 255, 0.05), transparent);
                pointer-events: none;
              }
            }

            .title-icon {
              width: 40px;
              height: 40px;
              border-radius: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 24px;
              flex-shrink: 0;
              position: relative;
              z-index: 1;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
            }

            .title-content {
              flex: 1;
              min-width: 0;
              position: relative;
              z-index: 1;
            }

            .ring-card-name {
              font-size: 26px;
              font-weight: 600;
              line-height: 1.3;
              text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
            }

            .ring-card-subtitle {
              font-size: 20px;
              color: #b0c4d9;
              margin-top: 2px;
              line-height: 1.2;
              font-weight: 600;
            }
          }
        }

        .legend-list {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 12px;
          margin-bottom: 24px;

          .legend-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 12px 10px;
            background: rgba(0, 217, 255, 0.05);
            border: 1px solid rgba(0, 217, 255, 0.12);
            border-radius: 8px;
            transition: all 0.3s;

            &:hover {
              border-color: rgba(0, 217, 255, 0.35);
              box-shadow: 0 0 12px rgba(0, 217, 255, 0.2);
            }

            .legend-value {
              display: flex;
              align-items: baseline;
              gap: 6px;
              color: #fff;
              font-size: 20px;
              font-weight: 600;

              .legend-number {
                font-size: 22px;
              }

              .legend-unit {
                font-size: 12px;
                color: #6b7d8f;
              }
            }

            .legend-name {
              margin-top: 6px;
              font-size: 13px;
              color: #8fa4b9;
              text-align: center;
            }

            .legend-chain {
              margin-top: 2px;
              font-size: 12px;
              color: #6b7d8f;
              text-align: center;
            }
          }
        }
      }

      // 下半部分：两个折线图
      .bottom-charts-section {
        flex: 1;
        min-height: 0;
        background: rgba(7, 20, 36, 0.45);
        border: 1px solid rgba(0, 217, 255, 0.2);
        border-radius: 8px;
        padding: 20px;

        .bar-charts-wrapper {
          display: flex;
          flex-direction: row; // 改为左右布局
          gap: 20px;
          height: 100%;

          .bar-chart-item {
            flex: 1;
            min-height: 0;
            display: flex;
            flex-direction: column;

            .chart-title {
              font-size: 16px;
              font-weight: 600;
              color: #00d9ff;
              margin-bottom: 15px;
              padding-bottom: 8px;
              border-bottom: 1px solid rgba(0, 217, 255, 0.2);
            }
          }
        }
      }
    }

    // 右侧区域
    .right-section {
      width: 520px;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .data-cards {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-template-rows: repeat(2, 1fr);
        gap: 10px;
        background: rgba(7, 20, 36, 0.45);
        border: 1px solid rgba(0, 217, 255, 0.2);
        border-radius: 8px;
        padding: 15px;

        .data-card {
          background: rgba(7, 20, 36, 0.6);
          border: 1px solid rgba(0, 217, 255, 0.15);
          border-radius: 12px;
          padding: 15px 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          text-align: center;
          transition: all 0.3s ease;
          cursor: pointer;
          position: relative;
          overflow: hidden;

          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: radial-gradient(circle at center, rgba(0, 217, 255, 0.08), transparent);
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          &:hover {
            border-color: rgba(0, 217, 255, 0.4);
            transform: translateY(-3px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);

            &::before {
              opacity: 1;
            }

            .card-icon {
              transform: scale(1.1);
            }
          }

          .card-icon {
            width: 50px;
            height: 50px;
            margin-bottom: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            // border-radius: 50%;
            // background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
            // backdrop-filter: blur(10px);
            // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
            // transition: all 0.3s ease;

            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              transition: transform 0.3s ease;
            }
          }

          .card-value {
            font-size: 30px;
            font-weight: 700;
            line-height: 1.2;
            margin-bottom: 6px;
            background: linear-gradient(180deg, #fff 0%, #d3d6dd 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          &.laomo-card {
            .card-value {
              background: none;
              -webkit-background-clip: unset;
              -webkit-text-fill-color: unset;
              background-clip: unset;
              color: #00ffff;
            }

            .card-label {
              color: #96d2e8;
            }
          }

          &.gongjiang-card {
            .card-value {
              background: none;
              -webkit-background-clip: unset;
              -webkit-text-fill-color: unset;
              background-clip: unset;
              color: #ffc800;
            }

            .card-label {
              color: #fff183;
            }
          }

          &.wuyi-jiangzhuang-card {
            .card-value {
              background: none;
              -webkit-background-clip: unset;
              -webkit-text-fill-color: unset;
              background-clip: unset;
              color: #fd6b6c;
            }

            .card-label {
              color: #ffcfe7;
            }
          }

          &.wuyi-jiangzhang-card {
            .card-value {
              background: none;
              -webkit-background-clip: unset;
              -webkit-text-fill-color: unset;
              background-clip: unset;
              color: #ff66a7;
            }

            .card-label {
              color: #ffcfe7;
            }
          }

          &.chuangxin-nengshou-card {
            .card-value {
              background: none;
              -webkit-background-clip: unset;
              -webkit-text-fill-color: unset;
              background-clip: unset;
              color: #00ffff;
            }

            .card-label {
              color: #c6ffff;
            }
          }

          &.gongren-xianfenghao-card {
            .card-value {
              background: none;
              -webkit-background-clip: unset;
              -webkit-text-fill-color: unset;
              background-clip: unset;
              color: #ff83ff;
            }

            .card-label {
              color: #ffecff;
            }
          }

          &.jinpai-gongren-card {
            .card-value {
              background: none;
              -webkit-background-clip: unset;
              -webkit-text-fill-color: unset;
              background-clip: unset;
              color: #fffd5c;
            }

            .card-label {
              color: #fff6ab;
            }
          }

          &.wenming-zhigong-card {
            .card-value {
              background: none;
              -webkit-background-clip: unset;
              -webkit-text-fill-color: unset;
              background-clip: unset;
              color: #79f3ff;
            }

            .card-label {
              color: #caffff;
            }
          }

          .card-label {
            font-size: 18px;
            color: #8fa4b9;
            font-weight: 800;
            letter-spacing: 0.5px;
            cursor: pointer;
          }
        }
      }

      // 轮播图区域
      .carousel-section {
        flex: 1;
        background: rgba(7, 20, 36, 0.45);
        border: 1px solid rgba(0, 217, 255, 0.2);
        border-radius: 8px;
        padding: 15px;
        display: flex;
        flex-direction: column;
        min-height: 0;

        .carousel-container {
          flex: 1;
          position: relative;
          overflow: hidden;
          border-radius: 8px;
          min-height: 0;

          .carousel-image {
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: 8px;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: transform 0.5s ease;
            }
          }

          .carousel-info {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
            padding: 20px 15px 15px;
            color: #fff;

            .carousel-company {
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              width: 100%;
              background: #057cfc;
              font-size: 20px;
              color: #fff;
              margin: 0;
              font-weight: 700;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              padding: 10px 0;
            }

            .carousel-title {
              font-size: 16px;
              font-weight: 600;
              color: #fff;
            }
          }
        }

        .carousel-dots {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
          margin-top: 12px;

          .carousel-title-label {
            font-size: 24px;
            font-weight: 700;
            color: #fff;
            margin-right: 12px;
          }

          .dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.3);
            cursor: pointer;
            transition: all 0.3s ease;

            &:hover {
              background: rgba(255, 255, 255, 0.6);
            }

            &.active {
              width: 24px;
              border-radius: 4px;
              background: #00d9ff;
            }
          }
        }
      }
    }
  }

  /* 数据列表覆盖层样式 - 确保响应式设计并完全覆盖左侧区域 */
  .data-list-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(7, 20, 36, 0.95);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .data-list-container {
    width: 95%;
    height: 95%;
    background: rgba(7, 20, 36, 0.98);
    border: 1px solid rgba(0, 217, 255, 0.3);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  }

  /* 适配不同屏幕尺寸 */
  @media screen and (max-width: 1200px) {
    .data-list-container {
      width: 98%;
      height: 98%;
    }
  }

  @media screen and (max-width: 768px) {
    .data-list-overlay {
      padding: 10px;
    }
    .data-list-container {
      width: 100%;
      height: 100%;
    }
  }

  .data-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid rgba(0, 217, 255, 0.2);
    background: rgba(7, 20, 36, 0.98);
    flex-shrink: 0;
  }

  .data-list-header h3 {
    margin: 0;
    font-size: 24px;
    color: #fff;
    font-weight: 700;
  }

  .close-btn {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 1px solid rgba(0, 217, 255, 0.6);
    background: transparent;
    color: #00d9ff;
    font-size: 22px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.25s ease;
    box-shadow: 0 0 12px rgba(0, 217, 255, 0.35);
  }

  .close-btn:hover {
    background: rgba(0, 217, 255, 0.12);
    color: #fff;
    box-shadow: 0 0 16px rgba(0, 217, 255, 0.6);
  }

  .close-button {
    background-color: #ff4d4f;
    color: white;
    border: none;
    padding: 8px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.3s ease;
  }

  .close-button:hover {
    background-color: #ff7875;
  }

  .data-table-wrapper {
    flex: 1;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }

  .data-table-container {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
  }

  .data-table {
    width: 100%;
    border-collapse: collapse;
    color: #fff;
    min-width: 600px;
  }

  .data-table th,
  .data-table td {
    padding: 12px 10px;
    text-align: center;
    border-bottom: 1px solid rgba(0, 217, 255, 0.2);
    border-right: 1px solid rgba(0, 217, 255, 0.1);
    font-size: 16px;
    line-height: 1.6;
    font-weight: 600;
    transition: all 0.2s ease;
    width: 140px;
    height: 46px;
    box-sizing: border-box;
  }

  .data-table th:last-child,
  .data-table td:last-child {
    border-right: none;
  }

  .data-table th {
    background: rgba(0, 217, 255, 0.1);
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .data-table tr {
    transition: background 0.2s ease;
  }

  .data-table tr:hover {
    background: rgba(0, 102, 255, 0.25);
  }

  .data-table tr:hover td {
    color: #ffffff;
    font-size: 18px;
    font-weight: 700;
  }

  .empty-message {
    text-align: center;
    color: #8fa4b9;
    padding: 40px;
    font-size: 16px;
  }

  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 20px;
    border-top: 1px solid rgba(0, 217, 255, 0.2);
    background: rgba(7, 20, 36, 0.98);
    flex-shrink: 0;
  }

  .pagination button {
    background: rgba(0, 217, 255, 0.1);
    border: 1px solid rgba(0, 217, 255, 0.3);
    color: #fff;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
  }

  .pagination button:hover:not(:disabled) {
    background: rgba(0, 217, 255, 0.2);
    border-color: rgba(0, 217, 255, 0.6);
  }

  .pagination button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .pagination .page-number {
    width: 34px;
    height: 34px;
    margin: 0 6px;
    border-radius: 8px;
    border: 1px solid transparent;
    background: rgba(255, 255, 255, 0.02);
    color: #8fa4b9;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.25s ease;
  }

  .pagination .page-number:hover {
    color: #fff;
    border-color: rgba(0, 217, 255, 0.35);
    box-shadow: 0 0 12px rgba(0, 217, 255, 0.3);
  }

  .pagination .page-number.active {
    color: #0a1f3b;
    background: linear-gradient(135deg, #00d9ff, #00a1ff);
    border-color: transparent;
    box-shadow: 0 0 14px rgba(0, 217, 255, 0.8);
    font-weight: 600;
  }

  .pagination-info {
    color: #8fa4b9;
    font-size: 14px;
    margin: 0 15px;
  }
}
</style>

